import { createSelector } from 'reselect';

const getSinistres = (state: any) => state.getIn(['sinistre', 'sinistres']);

const getSinistreDetails = (state: any) =>
  state.getIn(['sinistre', 'sinistreDetails']);

const getIsLoading = (state: any) => state.getIn(['sinistre', 'isLoading']);

export const getLastSinistre = createSelector(getSinistres, (sinistres) => {
  if (sinistres.toJS().length > 0) {
    return sinistres.toJS()[sinistres.toJS().length - 1][0];
  }
});

export const getAllSinistre = createSelector(getSinistres, (sinistres) => {
  if (sinistres.toJS().length > 0) {
    return sinistres.toJS();
  }
});

export const getSinistreDetailsSelector = createSelector(
  getSinistreDetails,
  (details) => {
    if (details.toJS().length > 0) {
      return details.toJS();
    }
  },
);

export const getIsLoadingSelector = createSelector(
  getIsLoading,
  (isLoading) => isLoading,
);

const getRefundsAMC = (state: any) => state.getIn(['sinistre', 'refundsAMC']);

export const getAllRefundsAMCSelector = createSelector(
  getRefundsAMC,
  (refunds) => {
    return refunds.toJS() ? refunds.toJS() : {};
  },
);

const getRefundAMCDetails = (state: any) =>
  state.getIn(['sinistre', 'refundDetail']);

export const getRefundAMCDetailsSelector = createSelector(
  getRefundAMCDetails,
  (refundDetail) => {
    return refundDetail ? refundDetail : {};
  },
);

export const getLastRefund = createSelector(getRefundsAMC, (refunds) => {
  const dates = Object.keys(refunds.toJS());
  dates.sort();
  if (dates.length > 0) {
    const lastRefund = refunds.toJS()[dates[dates.length - 1]][0];
    return lastRefund;
  }
  return {};
});

const getIsRefundsLoading = (state: any) =>
  state.getIn(['sinistre', 'isRefundsLoading']);

export const getIsRefundsLoadingSelector = createSelector(
  getIsRefundsLoading,
  (isRefundsLoading) => isRefundsLoading,
);

const getIsRefundDetailLoading = (state: any) =>
  state.getIn(['sinistre', 'isRefundDetailLoading']);

export const getIsRefundDetailLoadingSelector = createSelector(
  getIsRefundDetailLoading,
  (isRefundDetailLoading) => isRefundDetailLoading,
);
